export function GetMockDevelopmentList() {
  return [
    {
      id: 1,
      name: "Kingsbourne",
      addedByUserId: 4,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alexander.Scott@justmortgages.co.uk",
      phoneNumber: "07587038943 ",
      mainContactName: "Alexander Scott",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "2022-01-31T14:11:10.3400466",
      isDeleted: 0,
    },
    {
      id: 2,
      name: "The Fairways",
      addedByUserId: 4,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alexander.Scott@justmortgages.co.uk",
      phoneNumber: "07587038943 ",
      mainContactName: "Alexander Scott",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 3,
      name: "Stafford Road",
      addedByUserId: 4,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alexander.Scott@justmortgages.co.uk",
      phoneNumber: "07587038943",
      mainContactName: "Alexander Scott",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "2022-01-31T14:01:22.4359131",
      isDeleted: 0,
    },
    {
      id: 4,
      name: "Hazelwall Farm ",
      addedByUserId: 4,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alexander.Scott@justmortgages.co.uk",
      phoneNumber: "01206",
      mainContactName: "Alexander Scott",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-01T09:22:46.583375",
      isDeleted: 0,
    },
    {
      id: 5,
      name: "Victoria Central",
      addedByUserId: 4,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "alexander.scott@justmortgages.co.uk",
      phoneNumber: "01206",
      mainContactName: "Alexander Scott",
      podAllocationId: 62,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-01T09:23:08.131562",
      isDeleted: 0,
    },
    {
      id: 6,
      name: "Beaulieu Park ",
      addedByUserId: 4,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alexander.Scott@justmortgages.co.uk",
      phoneNumber: "07587038943",
      mainContactName: "Alex Scott",
      podAllocationId: 62,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 7,
      name: "Castellum Grange",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alexander.scott@justmortgages.co.uk",
      phoneNumber: "07587038943",
      mainContactName: "Alexander Scott",
      podAllocationId: 62,
      generalInfo: null,
      unitTypes: null,
      units: 10,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 8,
      name: "Mortimer Place",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alexander.scott@justmmortgages.co.uk",
      phoneNumber: "07587038943",
      mainContactName: "Alexander Scott",
      podAllocationId: 62,
      generalInfo: null,
      unitTypes: null,
      units: 12,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 9,
      name: "Ayletts Green",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "alexander.scott@justmortgages.co.uk",
      phoneNumber: "07587038943",
      mainContactName: "Alexander Scott",
      podAllocationId: 62,
      generalInfo: null,
      unitTypes: null,
      units: 8,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 17,
      name: "LD IT Test 2",
      addedByUserId: 4,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "lindsay.davey@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Lindsay D",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-30T16:00:29.3440712",
      isDeleted: 1,
    },
    {
      id: 22,
      name: "LD IT Test 11",
      addedByUserId: 4,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "lindsay@sh.co.uk",
      phoneNumber: null,
      mainContactName: "Lindsay D",
      podAllocationId: 90,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-07T12:29:49.331761",
      isDeleted: 1,
    },
    {
      id: 23,
      name: "825 Sapphire Fields",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Ellie.Tomlinson@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Ellie Tomlinson",
      podAllocationId: 63,
      generalInfo: "Dunmow",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-07T12:30:18.0934084",
      isDeleted: 0,
    },
    {
      id: 24,
      name: "Cringleford Heights",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 1,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-08T10:50:15.0852394",
      isDeleted: 0,
    },
    {
      id: 25,
      name: "Overstone Gate",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 1,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 26,
      name: "Cortlands Park",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 27,
      name: "Oak Farm Meadow",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 28,
      name: "Sewell Meadow",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 29,
      name: "The Vickers",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 4,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 30,
      name: "LD Test",
      addedByUserId: 4,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "ld@sh.co.uk",
      phoneNumber: null,
      mainContactName: "LD",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-08T13:22:52.578401",
      isDeleted: 1,
    },
    {
      id: 31,
      name: "Pedlars Meadow",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 3,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 32,
      name: "Pemberton Park",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 33,
      name: "Houghton Regis",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 34,
      name: "Daventry",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: "Northampton",
      units: 1,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 35,
      name: "Lavender Grange",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 2,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 36,
      name: "Shefford",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: "Stevenage",
      units: 1,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 37,
      name: "Madgwick Park",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Jon.Lacey@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Jon Lacey",
      podAllocationId: 63,
      generalInfo: "Grayshot office",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 38,
      name: "Colindale Gardens",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "paula.cozens@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Paula Cozens",
      podAllocationId: 63,
      generalInfo: "Colindale",
      unitTypes: "",
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-09T13:10:03.676613",
      isDeleted: 0,
    },
    {
      id: 39,
      name: "Bluenote Hounslow",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "paula.cozens@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Paula Cozens",
      podAllocationId: 63,
      generalInfo: "Hounslow",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 40,
      name: "Poets Meadow",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "carloshernandez@bjbmail.com",
      phoneNumber: null,
      mainContactName: "Carlos Hernandez",
      podAllocationId: 63,
      generalInfo: "Wolverhampton Branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 41,
      name: "Kings Moat Gardens",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "CarlosHernandez@bjbmail.com",
      phoneNumber: null,
      mainContactName: "Carlos Hernandez",
      podAllocationId: 63,
      generalInfo: "Northwich Branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 42,
      name: "Littler Lane",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "CarlosHernandez@bjbmail.com",
      phoneNumber: null,
      mainContactName: "Carlos Hernandez",
      podAllocationId: 63,
      generalInfo: "Winsford",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 43,
      name: "The Longlands",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "CarlosHernandez@bjbmail.com",
      phoneNumber: null,
      mainContactName: "Carlos Hernandez",
      podAllocationId: 63,
      generalInfo: "Wolverhampton",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 44,
      name: "Hawthorne Drive",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "CarlosHernandez@bjbmail.com",
      phoneNumber: null,
      mainContactName: "Carlos Hernandez",
      podAllocationId: 63,
      generalInfo: "Sandbach branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 45,
      name: "Stoneley Park",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "CarlosHernandez@bjbmail.com",
      phoneNumber: null,
      mainContactName: "Carlos Hernadez",
      podAllocationId: 63,
      generalInfo: "Winsford",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 46,
      name: "Billbrook",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "CarlosHernandez@bjbmail.com",
      phoneNumber: null,
      mainContactName: "Carlos Hernandez",
      podAllocationId: 63,
      generalInfo: "Wolverhampton branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 47,
      name: "Hampton Park",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alex.scott@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Alex Scott",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: "3",
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 48,
      name: "Copperfield Phase 2",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alex.scott@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Alex Scott",
      podAllocationId: 63,
      generalInfo: "14",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 49,
      name: "Channels",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alex.scott@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Alex Scott",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: "8",
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 50,
      name: "The Leas",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Hayley.Crittenden@haart.co.uk",
      phoneNumber: null,
      mainContactName: "Hayley Crittenden",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 8,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 51,
      name: "Monchelsea Park",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Hayley.Crittenden@haart.co.uk",
      phoneNumber: null,
      mainContactName: "Hayley Crittenden",
      podAllocationId: 63,
      generalInfo: "Maidstone Branch",
      unitTypes: null,
      units: 38,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 53,
      name: "Lucas Gardens",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alex.scott@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Alex Scott",
      podAllocationId: 63,
      generalInfo: "Stevenage Branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 54,
      name: "Hitchin Road",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alex.scott@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Alex Scott",
      podAllocationId: 63,
      generalInfo: "Stevenage Branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 55,
      name: "Monksmore Gardens",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "alex.scott@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Alex Scott",
      podAllocationId: 63,
      generalInfo: "Northampton Branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 56,
      name: "Haughley",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Russell.davies@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Ellie",
      podAllocationId: 63,
      generalInfo: "Ipswich branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 57,
      name: "Judith Gardens",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "jamie.bodle@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Jamie Bodle",
      podAllocationId: 63,
      generalInfo: "Peterborough Branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 58,
      name: "Bramblegate",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "jamie.bodle@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Jamie Bodle",
      podAllocationId: 63,
      generalInfo: "Derby",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 59,
      name: "Fleckney Road",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "jamie.bodle@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Jamie Bodle",
      podAllocationId: 63,
      generalInfo: "Leicester branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 60,
      name: "Staunton Park",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "jamie.bodle@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Jamie Bodle",
      podAllocationId: 63,
      generalInfo: "Leicester Branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 61,
      name: "Havenfield",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "jamie.bodle@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Jamie Bodle",
      podAllocationId: 63,
      generalInfo: "Lincoln Branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 62,
      name: "The Landings",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "jamie.bodle@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Jamie Bodle",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 63,
      name: "Bracebridge Heath",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "jamie.bodle@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Jamie Bodle",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 64,
      name: "Durose Country Park",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "jamie.bodle@spicerhaart.co.uk",
      phoneNumber: null,
      mainContactName: "Jamie Bodle",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 65,
      name: "The Lees",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "kevin.spencley@haart.co.uk",
      phoneNumber: null,
      mainContactName: "Kevin Spencley",
      podAllocationId: 63,
      generalInfo: "Ashford Branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 66,
      name: "Gilden Way",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "cassie.tovell@haart.co.uk",
      phoneNumber: null,
      mainContactName: "Cassie Tovell",
      podAllocationId: 63,
      generalInfo: "Harlow",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 67,
      name: "City Fields",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Alex.scott@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Alex Scott",
      podAllocationId: 63,
      generalInfo: "Barnsley Branch",
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 68,
      name: "Marnham Park",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "mark.alvis@justmortgages.co.uk",
      phoneNumber: null,
      mainContactName: "Mark Alvis",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 69,
      name: "Newhall",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Cassie.tovell@haart.co.uk",
      phoneNumber: null,
      mainContactName: "Cassie Tovell",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 88,
      name: "Cherry Tree Park",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "SamBowyer@bjbmail.com",
      phoneNumber: "07966 447520 ",
      mainContactName: "Sam Bowyer",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: "Crewe Branch",
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 107,
      name: "Norton Hall",
      addedByUserId: 47,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "SamBowyer@bjbmail.com",
      phoneNumber: null,
      mainContactName: "Sam Bowyer",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: "Cannock Branch",
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    {
      id: 171,
      name: "Forge Park",
      addedByUserId: 51,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Hayley.Crittenden@haart.co.uk",
      phoneNumber: "01233620340",
      mainContactName: "Hayley Crittenden",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T08:56:33.3229528",
      isDeleted: 1,
    },
    {
      id: 178,
      name: "Burton On Trent Breanch",
      addedByUserId: 51,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 1,
      emailAddress: "Roger.Jackson@haart.co.uk",
      phoneNumber: null,
      mainContactName: "Roger Jackson",
      podAllocationId: 63,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
  ];
}
